import SignUpConfirm from './SignUpConfirm'

export default SignUpConfirm
